import type { AllRouteEndpoints } from "../routeTypes";

export const appsAppGroupIdEmailDraganddropSettings = "/apps/:app_group_id/email/draganddrop_settings";
export const appsAppGroupIdEmailDraganddropSettingsCacheKeys: AllRouteEndpoints[] = [];
